export default __webpack_public_path__ + "static/media/live-traffic.71739d12.svg";